import { render, staticRenderFns } from "./UIProfileSearchWithProfileCards.vue?vue&type=template&id=c2478a88"
import script from "./UIProfileSearchWithProfileCards.vue?vue&type=script&lang=js"
export * from "./UIProfileSearchWithProfileCards.vue?vue&type=script&lang=js"
import style0 from "./UIProfileSearchWithProfileCards.vue?vue&type=style&index=0&id=c2478a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default})
